import React, { useEffect, useState } from "react";
import PropTypes from "prop-types"
import { getWithExpiry } from "../../../Helpers/LocalStorageHelper";
import { getById } from "../../../../Infrastructure/Services/DataService";
import { createdUpdatedAtValueFormat, formatColumnNames } from "../../../Helpers/StringFormatHelper";
import UITable from "../../UI/Table/Table";
import { toast } from "react-toastify";
import { displayNestedValues } from "../../../Helpers/DisplayHelper";

function GenericDetailsPage(props) {
    const [data, setData] = useState(null);
    const [notFound, setNotFound] = useState(false);

    const loadData = () => {
        var token = getWithExpiry("token");

        if (token === null) {
            props.setLoggedIn(false);
            return;
        }

        const search = window.location.search;
        const params = new URLSearchParams(search);
        let id = params.get('id');
        getById(props.endpoint, id, token, props.relations, props.withoutIsActiveFilter).then((data) => {
            if (data === null) {
                setNotFound(true);
            } else {
                setData(data);
            }
        }).catch((ex) => {
            toast.error(ex);
            setNotFound(true);
        })
    }

    useEffect(() => {
        loadData();
    }, []);

    return (
        <>
            <div className="d-flex justify-content-between mt-2">
                <p className="h3">{props.title}</p>
                <div>
                    {props.additionalButtons}
                </div>
            </div>

            <div className="mt-2">
                {notFound &&
                    <p className="text-danger h4">Entity not found</p>
                }

                {
                    !notFound && data &&
                    <>
                        <ul className="list-group">
                            {Object.entries(data).map((entry, index) => {
                                return <React.Fragment key={index}>
                                    {
                                        (!entry[0].includes("_id") ||(props.displayIds && props.displayIds.includes(entry[0]))) && 
                                        ((props.manyToManyRelations && props.manyToManyRelations.filter(x => x.name === entry[0]).length === 0) || !props.manyToManyRelations) &&
                                        ((props.oneToManyRelations && props.oneToManyRelations.filter(x => x.name === entry[0]).length === 0) || !props.oneToManyRelations)
                                        && <li className="list-group-item d-flex justify-content-between align-items-start" key={index}>
                                            <div className="ms-2 me-auto w-100">
                                                <span className="fw-bold me-2">{formatColumnNames(entry[0])}:</span>
                                                {!entry[1] ? "/" : typeof (entry[1]) !== "object" ? <>{entry[0] === "created_at" || entry[0] === "updated_at" ? createdUpdatedAtValueFormat(entry[1]) : isNaN(Number(entry[1])) ? entry[1].toString() : Number(entry[1])}</> : entry[1] &&
                                                    displayNestedValues(entry[1], index)
                                                }
                                            </div>
                                        </li>
                                    }
                                </React.Fragment>
                            })}
                        </ul>
                        {props.manyToManyRelations && <>
                            {props.manyToManyRelations.map((rel, index) => {
                                return <React.Fragment key={`rel-${index}`}>
                                    <div className="d-flex justify-content-between mt-4 mb-2">
                                        <p className="h4">{rel.title}</p>
                                    </div>
                                    {console.log(data[rel.name])}
                                    {data[rel.name].length > 0 ? 
                                    <UITable columnTitles={rel.columnTitles}
                                        data={props.withoutIsActiveFilter ? data[rel.name] : data[rel.name].filter(x => x.is_active === 1)}
                                        objectKeys={rel.objectKeys}
                                        primaryKey={'id'}
                                        lastElementRef={null}
                                        preventDelete={true}
                                        includeCheckMarks={false}
                                    ></UITable> : 
                                    <div className="alert alert-secondary" role="alert">No {rel.title} affiliated with the current {props.title.split(" Details")[0]}</div>}
                                </React.Fragment>
                            })}
                        </>}
                        {props.oneToManyRelations && <>
                            {props.oneToManyRelations.map((rel, index) => {
                                return <React.Fragment key={`rel-mo-${index}`}>
                                    <div className="d-flex justify-content-between mt-4 mb-2">
                                        <p className="h4">{rel.title}</p>            
                                    </div>
                                    {data[rel.name].length > 0 ? 
                                    <UITable columnTitles={rel.columnTitles}
                                        data={data[rel.name].filter(x => x.is_active === 1)}
                                        objectKeys={rel.objectKeys}
                                        primaryKey={'id'}
                                        lastElementRef={null}
                                        detailsHref={rel.detailsHref}
                                        preventDelete={true}
                                    ></UITable> : 
                                    <div className="alert alert-secondary" role="alert">No {rel.title} affiliated with the current {props.title.split(" Details")[0]}</div>}
                                </React.Fragment>
                            })}
                        </>}
                    </>
                }
            </div>
        </>
    )
}

GenericDetailsPage.propTypes = {
    setLoggedIn: PropTypes.func,
    endpoint: PropTypes.string,
    title: PropTypes.string,
    relations: PropTypes.arrayOf(PropTypes.string),
    withoutIsActiveFilter: PropTypes.bool,
    manyToManyRelations: PropTypes.arrayOf(PropTypes.object),
    oneToManyRelations: PropTypes.arrayOf(PropTypes.object)
}

export default GenericDetailsPage;